import { SignWrapper } from './SignWrapper';
import { SignInWrapperProps } from 'types';

export const SignInWrapper = ({ slides, children }: SignInWrapperProps) => {
  const redirect = typeof window !== 'undefined' ? window.location.search : '';

  return (
    <SignWrapper
      slides={slides}
      HeaderLinkDescription="Don't have an account?"
      headerLinkCaption="Sign Up"
      headerLink={'/sign-up' + redirect}
      linkId="sign-in-wrapper-sign-up"
    >
      {children && children}
    </SignWrapper>
  );
};
